import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';

export const GRADES_4_5_MATERIALS: GradeMaterials = {
  categories: [
    {
      headingEn: 'Introductory items',
      headingEs: 'Elementos introductorios',
      items: [
        {
          id: 'program-guide-4-5',
          labelEn: 'Program Guide 4—5',
          labelEs: 'Guía del programa 4—5',
          subLabelEn: 'website\'s program section',
          subLabelEs: 'sección del programa de la página web',
          filePath: 'assets/printables/en/4-5/Program_Guide_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Program_Guide_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-parents-4-5',
          labelEn: 'Letter to parents',
          labelEs: 'Carta para los padres',
          filePath: 'assets/printables/en/4-5/Letter_Parents_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Letter_Parents_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-administrator-4-5',
          labelEn: 'Letter to administrator',
          labelEs: 'Carta para los administradores',
          filePath: 'assets/printables/en/4-5/Letter_Administrator_4-5.docx',
          filePathEs: 'assets/printables/es/4-5/Letter_Administrator_4-5_ES.docx',
          iconType: 'doc'
        }
      ]
    },
    {
      headingEn: 'Employment',
      headingEs: 'Empleo',
      items: [
        {
          id: 'payday-video-4-5',
          labelEn: 'Payday video',
          labelEs: 'Video sobre el día de pago',
          filePath: 'assets/video/CE_S01.mp4',
          filePathEs: 'assets/video/CE_S01.mp4',
          iconType: 'video'
        },
        {
          id: 'job-application-4-5',
          labelEn: 'Job application',
          labelEs: 'Aplicación de trabajo',
          filePath: 'assets/printables/en/4-5/Job_Application_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Job_Application_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-offer-4-5',
          labelEn: 'Job offer',
          labelEs: 'Oferta de trabajo',
          filePath: 'assets/printables/en/4-5/Job_Offer_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Job_Offer_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-posters-4-5',
          labelEn: 'Job posters',
          labelEs: 'Afiches de trabajo',
          filePath: 'assets/printables/en/4-5/Job_Posters_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Job_Posters_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'paycheck-4-5',
          labelEn: 'Paycheck',
          labelEs: 'Sueldo',
          filePath: 'assets/printables/en/4-5/Paycheck_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Paycheck_4-5_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Banking',
      headingEs: 'Bancario/a',
      items: [
        {
          id: 'bank-log-4-5',
          labelEn: 'Bank log',
          labelEs: 'Registro bancario',
          filePath: 'assets/printables/en/4-5/Bank_Log_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Bank_Log_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bank-slips-4-5',
          labelEn: 'Bank slips',
          labelEs: 'Recibos bancarios',
          filePath: 'assets/printables/en/4-5/Bank_Slip_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Bank_Slip_4-5_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Fines',
      headingEs: 'Multas',
      items: [
        {
          id: 'fine-tickets-4-5',
          labelEn: 'Fine tickets',
          labelEs: 'Tiquetes de multa',
          filePath: 'assets/printables/en/4-5/Fine_Ticket_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Fine_Ticket_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'offense-log-4-5',
          labelEn: 'Offense log',
          labelEs: 'Registro de ofensas',
          filePath: 'assets/printables/en/4-5/Offense_Log_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Offense_Log_4-5_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Cash',
      headingEs: 'Dinero',
      items: [
        {
          id: 'bills-50-4-5',
          labelEn: '$50 bills',
          labelEs: 'Billetes de $50',
          subLabelEn: 'small bills: see grades 2—3',
          subLabelEs: 'facturas pequeñas: refiera los grados 2-3',
          filePath: 'assets/printables/en/4-5/Bills_50_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Bills_50_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-100-4-5',
          labelEn: '$100 bills',
          labelEs: 'Billetes de $100',
          filePath: 'assets/printables/en/4-5/Bills_100_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Bills_100_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-500-4-5',
          labelEn: '$500 bills',
          labelEs: 'Billetes de $500',
          filePath: 'assets/printables/en/4-5/Bills_500_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Bills_500_4-5_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Rent & deeds',
      headingEs: 'Alquiler y título de propiedad',
      items: [
        {
          id: 'rental-agreement-4-5',
          labelEn: 'Rental agreement',
          labelEs: 'Contrato de alquiler',
          filePath: 'assets/printables/en/4-5/Rental_Agreement_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Rental_Agreement_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'rent-log-4-5',
          labelEn: 'Rent log',
          labelEs: 'Registro de alquiler',
          filePath: 'assets/printables/en/4-5/Rent_Log_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Rent_Log_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'unpaid-rent-4-5',
          labelEn: 'Unpaid rent notice',
          labelEs: 'Aviso de renta no pagada',
          filePath: 'assets/printables/en/4-5/Unpaid_Rent_Notice_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Unpaid_Rent_Notice_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'desk-deed-4-5',
          labelEn: 'Deed to desk',
          labelEs: 'Título de propiedad del escritorio',
          filePath: 'assets/printables/en/4-5/Desk_Deed_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Desk_Deed_4-5_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Auctions',
      headingEs: 'Subastas',
      items: [
        {
          id: 'auction-video-4-5',
          labelEn: 'Auction video',
          labelEs: 'Video sobre subastas',
          filePath: 'assets/video/CE_S04.mp4',
          filePathEs: 'assets/video/CE_S04.mp4',
          iconType: 'video'
        },
        {
          id: 'auction-record-4-5',
          labelEn: 'Auction record form',
          labelEs: 'Formulario de registro de subasta',
          filePath: 'assets/printables/en/4-5/Auction_Record_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Auction_Record_4-5_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'auction-paddle-4-5',
          labelEn: 'Auction paddle',
          labelEs: 'Paleta de subastas',
          filePath: 'assets/printables/en/4-5/Auction_Paddle_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Auction_Paddle_4-5_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Year-end certificates',
      headingEs: 'Certificados de fin de año',
      items: [
        {
          id: 'saver-certs-4-5',
          labelEn: 'Saver certificates (Includes Saver, Super, and Ultimate awards)',
          labelEs: 'Certificado de ahorro (Incluye los premios Saver, Super y Ultimate)',
          filePath: 'assets/printables/en/4-5/Saver_Certs_4-5.pdf',
          filePathEs: 'assets/printables/es/4-5/Saver_Certs_4-5_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Posters & handouts',
      headingEs: 'Afiches y folletos',
      items: [
        {
          id: 'bonus-list-4-5',
          labelEn: 'Bonus list',
          labelEs: 'Lista de bonificaciones',
          filePath: 'assets/printables/en/4-5/Bonus_List_4-5.docx',
          filePathEs: 'assets/printables/es/4-5/Bonus_List_4-5_ES.doc',
          iconType: 'doc'
        },
        {
          id: 'fine-list-4-5',
          labelEn: 'Fine list',
          labelEs: 'Lista de multas',
          filePath: 'assets/printables/en/4-5/Fine_List_4-5.docx',
          filePathEs: 'assets/printables/es/4-5/Fine_List_4-5_ES.doc',
          iconType: 'doc'
        }
      ]
    }
  ],
  supplies: {
    headingEn: 'Supplies to have on hand',
    headingEs: 'Suministros para tener al alcance',
    items: [
      { labelEn: 'Envelopes', labelEs: 'Sobres' },
      { labelEn: 'Portfolio folders', labelEs: 'Carpetas de portafolios' },
      { labelEn: 'Cash drawer or box', labelEs: 'Caja de dinero' },
      { labelEn: 'Popsicle sticks for auction paddles', labelEs: 'Palos de paleta para las paletas de subasta' },
      { labelEn: 'Sticky notes', labelEs: 'Notas adhesivas' },
      { labelEn: 'Clipboard', labelEs: 'Portapapeles' },
      { labelEn: 'Auction items', labelEs: 'Artículos de subasta' }
    ]
  }
};
